import "core-js/stable";
import "regenerator-runtime/runtime";

import "./js/config.js";

// Load in vendor scripts (jquery loaded by Webpack directly);
import "bootstrap";

// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import './js/validation';
import 'sharer.js';

// Load in styles
import "./scss/styles.scss";

// Conditional dynamic imports

// Webpack will store those modules in separate JS files and
// load them on demand, keeping payload down.


// Load in custom JS modules required on initial page load

import('./js/viewport-size');

if (document.querySelector('body.site-layout') != null) {
    import('./js/scrolling');
    import('./js/keyboard-accessibility-check');
}

if (document.querySelector('.header--content--menu') != null) {
    import('./js/main-navigation');
}

if (document.querySelector('#header--content--search--show--btn') != null) {
    import('./js/header-search');
}

if (document.querySelector('#top-alert-message') != null) {
    import('./js/alert-message');
}

if (document.querySelector('#section-subnav') != null) {
    import('./modules/section-subnav/section-subnav.js');
}

if (document.querySelector('.resource-nav-wrapper') != null) {
    import('./js/resource-nav-wrapper.js');
}

if (document.querySelector('#checkout-time-remaining') != null) {
  import('./js/checkout-time-remaining');
}

if (document.querySelector('.js-account-organisation') != null) {
    import('./js/organisationAddress');
}

if (document.querySelector(".article") != null) {
    import('./js/highlighter');
}

if (document.querySelector("#report-post-modal") != null) {
    import('./js/report-post-modal');
}
if (document.querySelector(".js-tinymce") != null || document.querySelector(".js-tinymce-basic") != null) {
    import('./js/tinymce');
}
if(document.querySelector('.js-handle-subscribe') != null) {
    import('./js/subscribe');
}

// Load in custom JS modules on initial page load and when DOM is updated

const addDataJsParsed = (elements, tag = '') => {
    elements.forEach(x => {
        x.setAttribute(`data-js-parsed--${tag}`,'');
    });
}

const quickCheckQueries = [];
let quickCheckQueryComplete = false,
    quickCheckQueryString = null;
const addQuickCheckQuery = (s) => {
    if(!quickCheckQueryComplete) {
        quickCheckQueries.push(s);
        quickCheckQueryString = quickCheckQueries.toString();
    }
};
const jsModuleQuickCheck = async () => {
    let checkQuery = document.querySelector(quickCheckQueryString);
    if (checkQuery != null) jsModuleCheck();
};

const jsModuleCheck = async () => {

    let testQueryString = null,
        domQuery = null;

    // accordion open/close all
    testQueryString = '.accordion--open-close-all:not([data-js-parsed--accordion-open-close-all])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "accordion-open-close-all");
        await import('./js/accordion-open-close-all').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // collapse - expand for desktop
    testQueryString = '.expand-for-desktop:not([data-js-parsed--expand-for-desktop])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "expand-for-desktop");
        await import('./js/collapse-expand-for-desktop').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // expand-fragment
    testQueryString = '.accordion:not([data-js-parsed--expand-fragment])';
    addQuickCheckQuery(testQueryString);
    let fragment = window.location.hash;
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery != null && fragment != "") {
        addDataJsParsed(domQuery, "expand-fragment");
        await import('./js/expand-fragment').then((js) => {
            js.createFrom(domQuery);
        });
    }


    // smart-bootstrap-tabs
    testQueryString = '.nav[role="tablist"]:not([data-js-parsed--smart-bootstrap-tabs])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "smart-bootstrap-tabs");
        await import('./js/smart-bootstrap-tabs').then((js) => {
            js.createFrom(domQuery);
        });
    }


    // smart collapse trigger (from link or initial page url)
    testQueryString = '.collapse:not([data-js-parsed--smart-collapse])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "smart-collapse");
        await import('./js/smart-collapse-trigger').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // defer-iframe-content.js
    testQueryString = 'iframe.defer-iframe-content[data-src]:not([data-js-parsed--defer-iframe-content])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "defer-iframe-content");
        await import('./js/defer-iframe-content').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // height matching
    testQueryString = '*[data-hm-group]:not([data-js-parsed--height-match])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "height-match");
        await import('./js/height-match').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // hunt-watch
    testQueryString = '.hunt-watch:not([data-js-parsed--hunt-watch])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "hunt-watch");
        await import('./js/hunt-watch').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // section--scroll-reveal
    testQueryString = '.section--scroll-reveal:not([data-js-parsed--section--scroll-reveal])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "section--scroll-reveal");
        await import('./modules/section-scroll-reveal/section-scroll-reveal.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // hero video - vimeo
    testQueryString = '.hero--video.vimeo:not([data-js-parsed--vimeo])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "vimeo");
        await import('./js/hero-video-vimeo').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // hero video - youtube
    testQueryString = '.hero--video.youtube:not([data-js-parsed--youtube])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "youtube");
        await import('./js/hero-video-youtube').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // hero clickable
    testQueryString = '.hero--layout.clickable:not([data-js-parsed--hero-clickable])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "hero-clickable");
        await import('./js/hero-clickable').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // non-lazyload img-load-watcher
    testQueryString = 'img.img-load-watcher:not([data-js-parsed--img-load-watcher])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "img-load-watcher");
        await import('./js/img-load-watcher').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // image-loader-group
    testQueryString = '.image-loader-group:not([data-js-parsed--image-loader-group])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "image-loader-group");
        await import('./js/image-loader-group').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // lightboxes (PhotoSwipe v5 - galleries and single images)
    testQueryString = '.lightbox-image:not([data-js-parsed--lightbox]), .image-gallery:not([data-js-parsed--lightbox])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "lightbox");
        await import('./modules/lightboxes-galleries/lightboxes.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // data-sizes-js-fix (fixes lazysizes issue)
    testQueryString = '*[data-sizes-js-fix]:not([data-js-parsed--data-sizes-js-fix])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "data-sizes-js-fix");
        await import('./js/data-sizes-js-fix').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // fixed-bg-video
    testQueryString = '.fixed-bg-video:not([data-js-parsed--fixed-bg-video])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "fixed-bg-video")
        await import('./js/fixed-bg-video').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // testimonials-carousel
    testQueryString = '.testimonials-carousel:not([data-js-parsed--testimonials-carousel])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "testimonials-carousel");
        await import('./modules/testimonials-carousel/testimonials-carousel.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // marquee-scroller
    testQueryString = '.marquee-scroller:not([data-js-parsed--marquee-scroller])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "marquee-scroller");
        await import('./modules/marquee-scroller/marquee-scroller.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // stats-section
    testQueryString = '.stats-section:not([data-js-parsed--stats-section])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "stats-section");
        await import('./modules/stats-section/stats-section.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // responsive nav bar
    testQueryString = '.responsive-nav-bar:not([data-js-parsed--responsive-nav-bar])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "responsive-nav-bar");
        await import('./modules/responsive-nav-bar/responsive-nav-bar.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // responsive table
    testQueryString = '.responsive-table:not([data-js-parsed--responsive-table])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "responsive-table");
        await import('./modules/responsive-table/responsive-table.js');
    }

    // filter-listing (live and static)
    testQueryString = '.filter-listing:not([data-js-parsed--filter-listing])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "filter-listing");
        await import('./modules/filter-listing/filter-listing.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // width-watcher
    testQueryString = '*[data-width-watcher]:not([data-js-parsed--width-watcher])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "width-watcher");
        await import('./js/width-watcher').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // timeline
    testQueryString = '.timeline:not([data-js-parsed--timeline])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "timeline");
        await import('./modules/timeline/timeline.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // in-page-nav
    testQueryString = '.in-page-nav--wrapper:not([data-js-parsed--in-page-nav])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "in-page-nav");
        await import('./modules/in-page-nav/in-page-nav.js').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // form-check enable target
    testQueryString = 'input[data-form-check-enable-target]:not([data-js-parsed--form-check-enable-target])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "form-check-enable-target");
        await import('./js/form-check-enable-target').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // select-collapse-control
    testQueryString = 'select.select-collapse-control:not([data-js-parsed--select-collapse-control])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "select-collapse-control");
        await import('./js/select-collapse-control').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // radio-collapse-control
    testQueryString = '.radio-collapse-control:not([data-js-parsed--radio-collapse-control])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "radio-collapse-control");
        await import('./js/radio-collapse-control').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // booking-for-live-pricing
    testQueryString = '.booking-for-live-pricing:not([data-js-parsed--booking-for-live-pricing])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "booking-for-live-pricing");
        await import('./js/booking-for-live-pricing').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // .dropdown.dropdown-radio-list
    testQueryString = '.dropdown.dropdown-radio-list:not([data-js-parsed--dropdown-radio-list])';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        addDataJsParsed(domQuery, "dropdown-radio-list");
        await import('./js/dropdown-radio-list').then((js) => {
            js.createFrom(domQuery);
        });
    }

    // tripadvisor icon shiv
    testQueryString = '.fa-tripadvisor';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        await import('./js/tripadvisor-icon-shiv').then((js) => {
            js.createFrom(domQuery);
        });
    }
    
    // tiktok icon shiv
    testQueryString = '.fa-tiktok';
    addQuickCheckQuery(testQueryString);
    domQuery = document.querySelectorAll(testQueryString);
    if (domQuery.length > 0) {
        await import('./js/tiktok-icon-shiv').then((js) => {
            js.createFrom(domQuery);
        });
    }

};

//// create a mutation observer to watch for dynamically added HTML

let checkRequested = false, checkTimeout = null;

// run a check on page load
jsModuleCheck();

// Select the node that will be observed for mutations
const targetNode = document.querySelector('body');
if(targetNode != null) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList) {
        // Use traditional 'for loops' for IE 11
        let checkNeeded = false;
        for(const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                checkNeeded = true;
            }
        }
        if(checkNeeded && !checkRequested) {
            checkRequested = true;
            clearTimeout(checkTimeout);
            checkTimeout = setTimeout(() => {
                jsModuleQuickCheck();
                checkRequested = false;
            }, 100);
        }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    setTimeout(() => {
        // do another check now
        jsModuleQuickCheck();
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }, 3000);
}


// ecommerce js bits

const addressFinders = document.querySelectorAll('.js-find-address');

if (addressFinders.length) {
    addressFinders.forEach((x) => {
        addressFinder(x);
    })
}


const orderProcessing = document.querySelector('.js-order-processing');

if (orderProcessing) {
    setInterval(() => {
        fetch(`/Umbraco/Surface/OrderStatus/Get/?oid=${orderProcessing.dataset.oid}&pid=${orderProcessing.dataset.pid}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(response => {
                if (!response.processing) {
                    window.location = response.url
                }
                else {
                    document.querySelector('.js-processing-message').innerHTML = response.message;
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, 2000);
}
